/**
 * @file: isValidDate.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const isValidDate = (date: Date) => {
  return date instanceof Date && !isNaN(date as any);
};
